
import { createReducer } from 'redux-act';
import update from 'immutability-helper';

import { set_loaded_forms_items, save_forms_form, remove_forms_form } from '../actions';

const DEFAULT_STATE = {
    loaded: [],
    editing: [],
};

export default createReducer({
    [set_loaded_forms_items]:
        (state, payload) => {
            return update(state, { loaded: { $set: payload } });
        },
    [save_forms_form]:
        (state, payload) => {
            const {
                id,
                data,
                item,
            } = payload;

            const formDataToSave = {
                data,
                item,
                id,
                lastChangeTime: new Date(),
            }

            if (!state.editing) {
                return update(state, { editing: { $set: [formDataToSave] } });
            }

            const existingFormIndex = state.editing.findIndex(form => form.id === id);

            if (existingFormIndex !== -1) {
                return update(state, { editing: { [existingFormIndex]: { $set: formDataToSave } } });
            }

            return update(state, { editing: { $push: [formDataToSave] } });
        },
    [remove_forms_form]:
        (state, payload) => {
            const { id } = payload;

            const existingFormIndex = state.editing.findIndex(form => form.id === id);

            if (existingFormIndex !== -1) {
                return update(state, { editing: { $splice: [[existingFormIndex, 1]] } });
            }
        },
}, DEFAULT_STATE);
